import React, { FC } from 'react';

import { AppealFilter } from './blocks';
import { AppealFilterType } from './blocks/appeal-filter/types';
import { useGetAppealData } from './get-appeal-data';

const QmAppealFilter: FC<{
  setFilter: React.Dispatch<React.SetStateAction<AppealFilterType>>;
  filter: AppealFilterType;
}> = ({ filter, setFilter }) => {
  const { appealFilterKeys } = useGetAppealData();
  function onChangeFilter(filter: AppealFilterType) {
    setFilter(filter);
  }
  return (
    <div>
      <AppealFilter
        // titleMarkup={<div className="text-[18px] leading-[21px] text-1color font-bold">label</div>}
        data={filter}
        keysForFiltering={appealFilterKeys}
        onChangeHandler={onChangeFilter}
      />
    </div>
  );
};

export default QmAppealFilter;
